export const FOR_START_STATEMENT: string = '{% for ';
export const FOR_IN_STATEMENT: string = ' in ';
export const CLOSING_TAG: string = ' %}';
export const FOR_END_STATEMENT: string = '{% endfor %}';

export const COMMENT = (value: string) => `{# ${value} #}`
